import { render, staticRenderFns } from "./JasperReports.html?vue&type=template&id=0a8b2be7&external"
import script from "./JasperReports.ts?vue&type=script&lang=ts&external"
export * from "./JasperReports.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports